/**
 * Allowed route path prefixes for mmMode (Media Manager mode).
 * Mirrors the v6 webbuild sidebar navigation.
 * Users with the mediafactory.mmmode permission have access to these routes.
 * Matches are prefix-based: '/media' allows '/media', '/media/123', etc.
 */
const mmAllowedPrefixes: string[] = [
  // Core
  '/home',
  '/media',
  '/assets',
  '/members',
  '/member',

  // Gather
  '/upload',
  '/notifications',
  '/feeds',

  // Organize
  '/channels',
  '/groups',
  '/collections',

  // Applications
  '/widgets',
  '/applications',
  '/application',

  // Insights
  '/reports',
  '/audit-log',
  '/gamification',

  // Advanced Settings
  '/converter-queue',
  '/transfers',
  '/permissions',
  '/validation',
  '/metadata-config',
  '/settings',

  // Account & System
  '/profile',
  '/credentials',
  '/privacy',
  '/contests',
  '/login',
  '/403',
  '/404',
]

/**
 * Check if a given path is allowed in mmMode.
 * The root path '/' is always allowed (Dashboard).
 */
export function isAllowedInMmMode(path: string): boolean {
  if (path === '/') return true
  return mmAllowedPrefixes.some(prefix => path.startsWith(prefix))
}

export default mmAllowedPrefixes
